var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGeargIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2005 4.49438C19.8336 4.49438 20.3986 4.89193 20.6126 5.4878L21.3749 7.61118C21.4959 7.94509 21.7308 8.22565 22.0382 8.40351L24.2996 9.70906C24.6067 9.88624 24.9666 9.94897 25.3155 9.88613L27.5365 9.48546C28.1601 9.37206 28.7878 9.66276 29.1046 10.2118L30.3051 12.2826C30.6228 12.8301 30.5628 13.5181 30.1551 14.0023L28.698 15.7251C28.4685 15.996 28.3424 16.3394 28.3423 16.6945V19.3056C28.3424 19.6606 28.4685 20.0041 28.698 20.275L30.1551 21.9977C30.5628 22.4819 30.6228 23.1699 30.3051 23.7174L29.1046 25.7883C28.788 26.3367 28.1611 26.6273 27.538 26.5146L25.317 26.1139C24.9681 26.051 24.6082 26.1138 24.3011 26.291L22.0397 27.5965C21.7323 27.7744 21.4974 28.0549 21.3764 28.3888L20.6141 30.5122C20.3999 31.1086 19.8342 31.5062 19.2005 31.5056H16.7995C16.1664 31.5056 15.6014 31.1081 15.3874 30.5122L14.6251 28.3888C14.5041 28.0554 14.2699 27.7749 13.9633 27.5965L11.7004 26.291C11.3933 26.1138 11.0334 26.051 10.6844 26.1139L8.46352 26.5146C7.83987 26.628 7.21223 26.3373 6.89537 25.7883L5.69487 23.7174C5.37717 23.1699 5.4372 22.4819 5.84493 21.9977L7.30204 20.275C7.53153 20.0041 7.65755 19.6606 7.65769 19.3056V16.6945C7.65755 16.3394 7.53153 15.996 7.30204 15.7251L5.85994 14.0023C5.45221 13.5181 5.39218 12.8301 5.70988 12.2826L6.91038 10.2118C7.22703 9.66335 7.85387 9.37275 8.47703 9.48546L10.698 9.88613C11.0469 9.94897 11.4068 9.88624 11.7139 9.70906L13.9768 8.40351C14.2834 8.22508 14.5176 7.94466 14.6386 7.61118L15.4009 5.4878C15.6132 4.89656 16.1713 4.50014 16.7995 4.49438H19.2005Z",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 4.12672,
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGeargIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/GeargIcon.bdda433f.svg";
export { ForwardRef as ReactComponent };